/// <reference path="../../typings/externals.d.ts" />
exports.mocha = require('../../test/mocha');
var expect = exports.mocha.chai.expect;
var spy = exports.mocha.sinon.spy;
var mock = exports.mocha.mock;
var rcsdk = exports.mocha.rcsdk;
describe('RCSDK.helpers.BlockedNumber', function () {
    'use strict';
    var BlockedNumber = rcsdk.getBlockedNumberHelper();
    describe('createUrl', function () {
        it('returns URL depending on options', function () {
            expect(BlockedNumber.createUrl()).to.equal('/account/~/extension/~/blocked-number');
            expect(BlockedNumber.createUrl({ extensionId: 'foo' })).to.equal('/account/~/extension/foo/blocked-number');
            expect(BlockedNumber.createUrl({ extensionId: 'foo' }, 'bar')).to.equal('/account/~/extension/foo/blocked-number/bar');
        });
    });
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/lib/helpers/BlockedNumber-spec.ts
 ** module id = 77
 ** module chunks = 2
 **/